/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  MANIFEST,
  MANIFEST_FILE_UPLOAD,
  MANIFEST_ORDER,
  MANIFEST_UPDATE_ORDER_STATUS
} from "../constants/url.constant";

import { API } from "../api";

export const GET_ALL_MANIFEST = "GET_ALL_MANIFEST";
export const DELETE_MANIFEST = "DELETE_MANIFEST";
export const GET_CLIENT_PICKUP_REQUEST = "GET_CLIENT_PICKUP_REQUEST";
export const SET_CLIENT_PICKUP_LIST = "SET_CLIENT_PICKUP_LIST";

export const uploadAWBFile = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(MANIFEST_FILE_UPLOAD, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const updateManifestOrdersStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(MANIFEST_UPDATE_ORDER_STATUS, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const createManifest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(MANIFEST, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getAllManifest = (body = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.post(`${MANIFEST}/filter`, body);
      dispatch({
        type: GET_ALL_MANIFEST,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getManifestById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${MANIFEST}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addManifestFile = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(`${MANIFEST}/${id}/files`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getManifestFiles = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${MANIFEST}/${id}/files`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getFileLink = (id, fileId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${MANIFEST}/${id}/files/${fileId}/link`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateManifest = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${MANIFEST}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeManifestOrder = (orderId, id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${MANIFEST_ORDER}/${orderId}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeManifest = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${MANIFEST}/${id}`);
      dispatch({
        type: DELETE_MANIFEST,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_MANIFEST:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_MANIFEST:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((manifest) => manifest.MAWB !== payload)
      };
    default:
      return state;
  }
}
